import React from 'react'
import { Box, Typography } from '@mui/material'
import AssessmentIcon from '@mui/icons-material/Assessment';

const Mode7 = (props) => {
    //console.log(props)
    return (
        <Box sx={{textAlign: "center"}}>
            <AssessmentIcon sx={{fontSize: "60px"}}/>
            <Typography variant="h5" >{props.SurveyDisplayMode7Frame.SurveyCompletedHeadlineText2}</Typography>

        </Box>
    )
}

export default Mode7